import Vue from 'vue'
import ElementUI from 'element-ui'
import GC from 'gclife-common-front'
import App from './App.vue'
import router from './router'
import { init } from './config'
import store from '@/store'

Vue.config.productionTip = false

// 当前访问路径
window.localHost = process.env.NODE_ENV === 'development' ? 'https://dev-bmp-message.zjlh.lan' : window.location.origin

// element第三方插件
Vue.use(ElementUI)
// gclife自定义插件
Vue.use(GC)

// 配置初始化
init()

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js